import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const Base_Url = process.env.REACT_APP_BASE_API_URL || 'http://localhost:3000/api';

const ShoppingDeals = () => {
    const [hotDeals, setHotDeals] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchHotDeals = async () => {
            try {
                setLoading(true);
                const response = await axios.get(`${Base_Url}/shopping/hotdeals`);
                
                if (response.data.status === 'success') {
                    setHotDeals(response.data.result.brands || []);
                } else {
                    setError('Failed to load hot deals');
                }
            } catch (err) {
                console.error('Error fetching hot deals:', err);
                setError('Failed to load hot deals. Please try again.');
            } finally {
                setLoading(false);
            }
        };

        fetchHotDeals();
    }, []);
    // Don't render anything if there's an error or no data
    if (error || (!loading && hotDeals.length === 0)) {
        return null;
    }

    return (
        <section className="tp-deals-area pb-50">
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="tp-shop-main-wrapper">
                            <div className="tp-shop-items-wrapper tp-shop-item-primary">
                                <div className="row mt-20 mb-35">
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                        <h3 className="tp-section-title text-center">
                                            <span>Shopping Deals</span>
                                        </h3>
                                    </div>
                                </div>
                                <div className="row tp_home_deals justify-content-center">
                                    {loading ? (
                                        Array(4).fill(0).map((_, i) => (
                                            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6" key={i}>
                                                <Skeleton height={250} />
                                            </div>
                                        ))
                                    ) : (
                                        hotDeals.map((deal) => {
                                            const hotDeal = deal.latestHotDeal;
                                            const discountText = hotDeal?.discountPercentage 
                                                ? `${hotDeal.discountPercentage}% Off` 
                                                : 'Hot Deal';
                                            const dealTitle = hotDeal?.title || deal.description || 'Special offers available';
                                            
                                            return (
                                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6" key={deal._id}>
                                                    <Link to={`/product/${deal._id}`} state={{ filterLabel: "Hot Deals" }}>
                                                        <div className="tp-product-item mb-40">
                                                            <div className="tp-product-thumb p-relative z-index-1">
                                                                <img 
                                                                    src={deal.brandLogo || "/assets/img/brands/no_brand.png"} 
                                                                    alt={deal.name} 
                                                                />
                                                                <div className="hot_deals">
                                                                    <i className="fa-solid fa-fire-flame-curved mr-5"></i>
                                                                    {discountText}
                                                                </div>
                                                            </div>
                                                            <div className="tp-product-content">
                                                                <h3 className="tp-product-title">{deal.name}</h3>
                                                                <div className="tp-product-tag pt-5">
                                                                    {dealTitle}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </div>
                                            );
                                        })
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ShoppingDeals;